import { render, staticRenderFns } from "./InputAmount.vue?vue&type=template&id=23dd0012&scoped=true&"
import script from "./InputAmount.vue?vue&type=script&lang=js&"
export * from "./InputAmount.vue?vue&type=script&lang=js&"
import style0 from "./InputAmount.vue?vue&type=style&index=0&id=23dd0012&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd0012",
  null
  
)

export default component.exports